export default __webpack_public_path__ + "static/media/kitchen3-afterK-480w.91a6e97f.avif";